import React from 'react';
import { Box, Alert, Typography, Paper } from '@mui/material';

/**
 * 测试结果面板组件
 * 显示代码测试的结果
 */
function TestResultPanel({ runResult, userRole }) {
  if (!runResult) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" color="text.disabled" gutterBottom>
          No test results yet
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Click "Run with public test" to test your code with test cases
          {userRole === 'teacher' && ' or "Run with secret test" to test with secret test cases'}
        </Typography>
      </Box>
    );
  }

  const getSeverity = () => {
    if (runResult.status === 'passed') return 'success';
    if (runResult.status === 'error') return 'warning';
    return 'error';
  };

  const getTitle = () => {
    if (runResult.status === 'passed') return '✅ All Tests Passed!';
    if (runResult.status === 'error') return '⚠️ Runtime Error';
    return '❌ Some Tests Failed';
  };

  // Filter out DEBUG lines from output
  const filteredOutput = runResult.output
    ? runResult.output
        .split('\n')
        .filter(line => !line.includes('DEBUG') && !line.includes('[Python Runner]'))
        .join('\n')
    : '';

  return (
    <Box sx={{ p: 2, height: '100%', overflow: 'auto' }}>
      <Alert severity={getSeverity()} sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {getTitle()}
        </Typography>
        {runResult.testResults && (
          <Typography variant="body1" gutterBottom>
            <strong>
              {runResult.testResults.passed || 0}/{runResult.testResults.attempted || 0}
            </strong> test cases passed
          </Typography>
        )}
        {runResult.score !== undefined && (
          <Typography variant="body1">
            Score: <strong>{runResult.score}/100</strong>
          </Typography>
        )}
      </Alert>

      {/* Detailed Output */}
      {filteredOutput && (
        <Box>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Test Output
          </Typography>
          <Paper
            sx={{
              p: 2,
              bgcolor: 'grey.900',
              color: 'grey.100',
              fontFamily: 'monospace',
              fontSize: '12px',
              overflow: 'auto',
              maxHeight: 400
            }}
          >
            <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
              {filteredOutput}
            </pre>
          </Paper>
        </Box>
      )}

      {runResult.errorMessage && runResult.status === 'error' && (
        <Alert severity="error" sx={{ mt: 2 }}>
          <Typography variant="body2">
            {runResult.errorMessage}
          </Typography>
        </Alert>
      )}
    </Box>
  );
}

export default TestResultPanel;

